import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import centralized translation files
import enTranslations from './locales/en.json';
import viTranslations from './locales/vi.json';

// Configure i18n with centralized translations
const resources = {
  en: {
    translation: enTranslations,
  },
  vi: {
    translation: viTranslations,
  },
};

// Configure i18n
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    lng: 'vi', // Default language - Vietnamese
    fallbackLng: 'vi', // Fallback language - Vietnamese
    debug: false, // Set to true for debugging

    // Normalize language codes (vi-VN -> vi, en-US -> en)
    load: 'languageOnly',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Language detection options - only check localStorage (not browser)
    detection: {
      order: ['localStorage'], // Only check localStorage for user preference
      caches: ['localStorage'], // Cache selected language to localStorage
      lookupLocalStorage: 'i18nextLng', // Key name in localStorage
    },
  });

export default i18n;
